import { releaseDetailsManager } from "./ReleaseDetails.slice";

export const releaseDetailsManagerActions = { ...releaseDetailsManager.actions };
